import React from "react";

import anniversaryLogo from "../../assests/anniversary_logo.jpg";

export default function NoticeSectionComponent() {
  const messages = [
    {
      id: 1,
      image: anniversaryLogo,
      title: "Celebrating 85 Years of the Glorious Legacy of Vidyaloka",
      message:
        "For eighty five remarkable years, Vidyaloka College has stood as a proud symbol of knowledge, discipline, character, and excellence. From its humble beginnings to its present stature as one of the most respected educational institutions in the region, the college has continuously nurtured generations of young minds, shaping them into responsible citizens, leaders, professionals, and proud Vidyalokans. Throughout these decades, Vidyaloka has been guided by the vision and dedication of inspiring principals, devoted teachers, and supportive parents who have worked tirelessly to build a strong academic and moral foundation for every student who walks through its gates. \n\nThe legacy of Vidyaloka is not measured only by the passing of years, but by the countless achievements of its students and alumni who have brought honour and recognition to their alma mater across Sri Lanka and around the world. Whether in academics, sports, arts, leadership, or public service, Vidyalokans have consistently upheld the values and traditions instilled within the walls of this great institution. \n\nAs we proudly commemorate the 85th anniversary of Vidyaloka College, the Old Boys' Association joins hands with the entire Vidyaloka community to celebrate this extraordinary journey. This milestone stands as a tribute to the past, a celebration of the present, and an inspiration for the future. With unity, pride, and gratitude, we honour the remarkable legacy of our beloved college and reaffirm our commitment to preserving its traditions while guiding future generations toward even greater heights.",
      imagePosition: "right",
      fade: "right",
    },
  ];

  return (
    <section className="pt-5" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container px-3">
        {messages.map((msg, index) => (
          <div
            key={msg.id}
            className={index === messages.length - 1 ? "" : "mb-5"}
            data-aos={msg.fade === "left" ? "fade-right" : "fade-left"}
          >
            <div className="card rounded-3 border-vcg-muted">
              <div className="card-body p-0">
                <div className="row g-0">
                  {/* Image Section - Left */}
                  {msg.imagePosition === "left" && (
                    <div
                      className="
                        col-lg-4
                        d-flex
                        align-items-center
                        justify-content-center
                        px-4
                        pt-3
                        pb-4
                        p-lg-5
                      "
                    >
                      <div className="text-center">
                        <img
                          src={msg.image}
                          alt={msg.title}
                          className="rounded-3 border-vcg-muted img-fluid"
                          style={{
                            maxWidth: "320px",
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  )}

                  {/* Message Section */}
                  <div className="col-lg-8 d-flex align-items-center p-4 p-lg-5">
                    <div>
                      <h3 className="fw-bold mb-4">{msg.title}</h3>

                      <p className="mb-0 text-secondary">{msg.message}</p>
                    </div>
                  </div>

                  {/* Image Section - Right */}
                  {msg.imagePosition === "right" && (
                    <div
                      className="
                        col-lg-4
                        d-flex
                        align-items-center
                        justify-content-center
                        px-4
                        pt-3
                        pb-4
                        p-lg-5
                      "
                    >
                      <div className="text-center">
                        <img
                          src={msg.image}
                          alt={msg.title}
                          className="rounded-3 border-vcg-muted img-fluid"
                          style={{
                            maxWidth: "320px",
                            width: "100%",
                            height: "auto",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
